export default __webpack_public_path__ + "static/media/marty-controller.1ac87d65.mp4";